import { selectBlockedUsers, selectBlockedUsersCount } from 'client/redux/pubnub/selectors';

import { useAppSelector } from './redux';

export const useBlockedList = () => {
  const blockedList = useAppSelector(selectBlockedUsers);
  const blockedListTotal = useAppSelector(selectBlockedUsersCount);

  return { blockedList, blockedListTotal };
};
